module.exports = __webpack_public_path__ + "img/grandpa.3693b5ce.jpg";